<template>
    <v-row class="align-center" :class="`${arabic?'arFont':'enFont'}`">
      <v-col cols="12" md="3" :class="`${arabic?'arFont':'enFont'} py-0`">
        {{ i18n["call_or_call_trial"] }}
      </v-col>
      <v-col cols="12" md="3" :class="`${arabic?'arFont':'enFont'} py-0`">
        <v-chip label x-small class="primary" dark v-if="update.status && statuses_obj[update.status]">{{statuses_obj[update.status][language]}}</v-chip>
        <v-chip label x-small class="primary" dark v-if="update.status && !statuses_obj[update.status]">{{ i18n["call_trial"] }}</v-chip>
      </v-col>
      <v-col cols="12" md="3" :class="`${arabic?'arFont':'enFont'} py-0`">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">{{getFormat(update.call_time)}}</span>
          </template>
          <div class="text-center">
            <div :class="`${arabic?'arFont':'enFont'}`">
              {{update.call_time}}
            </div>
          </div>
        </v-tooltip>
      </v-col>
      <v-col cols="12" md="3" :class="`${arabic?'arFont':'enFont'} py-0`">
        <v-chip label x-small>NINJA SELLERS SYSTEM</v-chip>
      </v-col>
    </v-row>
</template>

<script>
import { format, render, cancel, register } from 'timeago.js';
export default {
  props:['update'],
  data(){
    return {
      dialog:true,
    }
  },
  methods:{
    getFormat(d){
      return format(d)
    },
  },
  computed:{
    statuses_obj(){
      console.log(this.$store.state.call_statuses_obj)
      return this.$store.state.call_statuses_obj
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
}
</script>

<style>

</style>